import React, { useState } from 'react';

const Dropdown = ({
  value,
  onChange,
  options = [],
  placeholder = 'اختر...',
  disabled = false,
  error,
  label,
  required = false,
  className = ''
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const selectClasses = `input-field cursor-pointer appearance-none ${error ? '!border-red-400 focus:!border-red-500' : ''} ${className}`;

  return (
    <div className="w-full">
      {label && (
        <label className={`block text-sm font-medium mb-2 transition-colors duration-200 ${
          isFocused ? 'text-blue-600' : 'text-gray-700'
        }`}>
          {label}
          {required && <span className="text-red-500 mr-1">*</span>}
        </label>
      )}

      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          disabled={disabled}
          className={selectClasses}
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {/* Custom dropdown arrow */}
        <div className="absolute start-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      {error && (
        <span className="text-sm text-red-600 mt-1 block">
          {error}
        </span>
      )}
    </div>
  );
};

export default Dropdown;